import React from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import ninja from "@vitalsource/vstui/colors/ninja";
import { withAllMatches } from "../../../components/mediaquery/breakpoints";
import Search from "./search";
import { Logo } from "./logo";
import HeaderNav from "./nav";
import MobileHeader from "./mobile-header";
import { actions as libraryActions } from "../../../../redux/ui/library";
import { selectors as brandSelectors } from "../../../../redux/brand";

export const NAV_HEADER_HEIGHT = 44;

const StyledHeader = styled.header`
  align-items: center;
  background: ${ninja.getShade(11)};
  display: flex;
  flex-grow: 0;
  height: ${NAV_HEADER_HEIGHT + "px"};
  justify-content: space-between;
  left: ${props => props.offset}px;
  min-height: ${NAV_HEADER_HEIGHT + "px"};
  padding-right: ${props => (props.isSmall ? "24px" : "")};
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 3;
`;
class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    if (this.props.isSmall) {
      return (
        <MobileHeader
          isSmall={this.props.isSmall}
          offset={this.props.offset}
          librarySearch={this.props.librarySearch}
        />
      );
    }

    return (
      <StyledHeader>
        <Logo />
        {this.props.librarySearch && <Search />}
        <HeaderNav />
      </StyledHeader>
    );
  }
}

const mapStateToProps = state => ({
  librarySearch: brandSelectors.getBrandValue(state, "Library.search", true)
});

const mapDispatchToProps = dispatch => ({
  toggleMobileHeaderMenu: () =>
    dispatch(libraryActions.toggleMobileHeaderMenu())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withAllMatches(Header));
